const BreadCrumb = ({ className = 'breadcrumb', children }) => {
    return(
        <div className={className}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    {children}
                </ol>
            </nav>
        </div>
    );
}

export default BreadCrumb;